@if (translationsLoaded) {
  <div class="open-registration-search">
    <div class="open-registration-search__input">
      <se-fe-toolbar
        [seFeDataQuery]="searchTerm"
        [seFeDataSearchDebounce]="300"
        [seFeDataSearchMinLength]="1"
        [seFeDataSearchPlaceholder]="translationKey + 'SEARCH.placeholder' | translate"
        [seFeDataAriaLabel]="translationKey + 'SEARCH.placeholder' | translate"
        (seFeQueryChange)="handleSearchQueryChange($event)">
      </se-fe-toolbar>
    </div>
    <se-po-open-registration-filter
      class="open-registration-search__filters"
      [sports]="sports"
      [signupTypeList]="signupTypeList"
      [organizations]="organizations"
      [people]="people"
      [showPersonFilter]="showPersonFilter"
      [filters]="filters"
      (filtersChange)="handleFiltersChange($event)"
      (filterAction)="handleFilterAction($event)">
    </se-po-open-registration-filter>
  </div>
}
